module.exports = __webpack_public_path__ + "img/down-left.08abe485.svg";